import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PortalSettingsService {
  private PortalSettings;
  constructor() { }

  public setPortalSettings(value) {
    this.PortalSettings = value;
  }

  public getPortalSettings() {
    return this.PortalSettings;
  }
}
